
export enum SubmissionActionTypes {
    SET_SUBMISSION_SUBMITTING = "SET_SUBMISSION_SUBMITTING",
    SET_SUBMISSION_PROCESSING = "SET_SUBMISSION_PROCESSING",
    SET_SUBMISSION_COMPLETE = "SET_SUBMISSION_COMPLETE",
    SET_SUBMISSION_FAILED = "SET_SUBMISSION_FAILED",
    RESET_SUBMISSION_SUBMIT_STATUS = "RESET_SUBMISSION_SUBMIT_STATUS"
}

type SetSubmissionSubmittingAction = {
    type: SubmissionActionTypes.SET_SUBMISSION_SUBMITTING;
    payload: { isSubmitting: boolean };
};

export const setSubmissionSubmitting = (isSubmitting: boolean): SetSubmissionSubmittingAction => ({
    type: SubmissionActionTypes.SET_SUBMISSION_SUBMITTING,
    payload: { isSubmitting }
});

type SetSubmissionProcessingAction = {
    type: SubmissionActionTypes.SET_SUBMISSION_PROCESSING;
    payload: { isProcessing: boolean };
};

export const setSubmissionProcessing = (isProcessing: boolean): SetSubmissionProcessingAction => ({
    type: SubmissionActionTypes.SET_SUBMISSION_PROCESSING,
    payload: { isProcessing }
});

type SetSubmissionCompleteAction = {
    type: SubmissionActionTypes.SET_SUBMISSION_COMPLETE;
    payload: { isComplete: boolean };
};

export const setSubmissionComplete = (isComplete: boolean): SetSubmissionCompleteAction => ({
    type: SubmissionActionTypes.SET_SUBMISSION_COMPLETE,
    payload: { isComplete }
});

type SetSubmissionFailedAction = {
    type: SubmissionActionTypes.SET_SUBMISSION_FAILED;
    payload: { failed: boolean };
};

export const setSubmissionFailed = (failed: boolean): SetSubmissionFailedAction => ({
    type: SubmissionActionTypes.SET_SUBMISSION_FAILED,
    payload: { failed }
});

type ResetSubmissionSubmitStatusAction = {
    type: SubmissionActionTypes.RESET_SUBMISSION_SUBMIT_STATUS
};

export const resetSubmissionSubmitStatus = (): ResetSubmissionSubmitStatusAction => ({
    type: SubmissionActionTypes.RESET_SUBMISSION_SUBMIT_STATUS
});

export type SubmissionActions =
    SetSubmissionSubmittingAction |
    SetSubmissionProcessingAction |
    SetSubmissionCompleteAction |
    SetSubmissionFailedAction |
    ResetSubmissionSubmitStatusAction